import Vue from 'vue'
import Vuex from 'vuex'
import drawer from './modules/drawer'
import avaliableActions from './modules/avaliableActions'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    drawer,
    avaliableActions
  }
})
